module.exports = __webpack_public_path__ + "img/flag-en.8117dd54.svg";